import { useContext, useEffect, useState } from 'react';
import { EditContext } from '../context/EditContext';

export function usePortfolio() {
  const [items, setItems] = useState(null);
  const { configVersion } = useContext(EditContext);
  useEffect(() => {
    let cancelled = false;
    fetch('/api/portfolio')
      .then((r) => r.json())
      .then((d) => { if (!cancelled) setItems(d.items || []); })
      .catch(() => { if (!cancelled) setItems([]); });
    return () => { cancelled = true; };
  }, [configVersion]);
  return { items };
}
